import { common, InvalidFormatError } from '../../common';
import { crypto } from '../../crypto';
import { utils } from '../../utils';
import { createSerializeWire } from '../Serializable';
import { WitnessModel } from '../WitnessModel';
export const MAX_TRANSACTION_ATTRIBUTES = 16;
export class TransactionBaseModel {
    constructor({ version, type, attributes = [], inputs = [], outputs = [], scripts = [], hash, }) {
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.serializeUnsigned = createSerializeWire(this.serializeUnsignedBase.bind(this));
        this.hashHexInternal = utils.lazy(() => common.uInt256ToHex(this.hash));
        this.messageInternal = utils.lazy(() => this.serializeUnsigned());
        this.version = version === undefined ? this.constructor.VERSION : version;
        this.type = type;
        this.attributes = attributes;
        this.inputs = inputs;
        this.outputs = outputs;
        this.scripts = scripts;
        const hashIn = hash;
        this.hashInternal = hashIn === undefined ? utils.lazy(() => crypto.hash256(this.message)) : () => hashIn;
        if (this.attributes.length > MAX_TRANSACTION_ATTRIBUTES) {
            throw new InvalidFormatError(`Expected less than ${MAX_TRANSACTION_ATTRIBUTES} attributes, found: ${attributes.length}`);
        }
    }
    get hash() {
        return this.hashInternal();
    }
    get hashHex() {
        return this.hashHexInternal();
    }
    get message() {
        return this.messageInternal();
    }
    sign(key) {
        return this.clone({
            scripts: this.scripts.concat([
                crypto.createWitness(this.serializeUnsigned(), key, this.constructor.WitnessConstructor),
            ]),
        });
    }
    signWithSignature(signature, publicKey) {
        return this.clone({
            scripts: this.scripts.concat([
                crypto.createWitnessForSignature(signature, publicKey, this.constructor.WitnessConstructor),
            ]),
        });
    }
    serializeExclusiveBase(_writer) {
    }
    serializeUnsignedBase(writer) {
        writer.writeUInt8(this.type);
        writer.writeUInt8(this.version);
        this.serializeExclusiveBase(writer);
        writer.writeArray(this.attributes, (attribute) => {
            attribute.serializeWireBase(writer);
        });
        writer.writeArray(this.inputs, (input) => {
            input.serializeWireBase(writer);
        });
        writer.writeArray(this.outputs, (output) => {
            output.serializeWireBase(writer);
        });
    }
    serializeWireBase(writer) {
        this.serializeUnsignedBase(writer);
        writer.writeArray(this.scripts, (script) => {
            script.serializeWireBase(writer);
        });
    }
}
TransactionBaseModel.VERSION = 0;
TransactionBaseModel.WitnessConstructor = WitnessModel;

//# sourceMappingURL=TransactionBaseModel.js.map
